import React from 'react';
import { FileText, AlertCircle, Clock, Star } from 'lucide-react';

export default function RequestStats({ requestCounts }) {
  const stats = [
    {
      title: 'Total Requests',
      value: requestCounts.all,
      icon: FileText,
      color: 'blue'
    },
    {
      title: 'Open',
      value: requestCounts.open,
      icon: AlertCircle,
      color: 'blue'
    },
    {
      title: 'In Progress',
      value: requestCounts.inProgress,
      icon: Clock,
      color: 'yellow'
    },
    {
      title: 'Escalated',
      value: requestCounts.escalated,
      icon: Star,
      color: 'red'
    }
  ];

  return (
    <div className="request-stats">
      {stats.map((stat, index) => {
        const IconComponent = stat.icon;
        
        return (
          <div key={index} className="stat-card">
            <div className="stat-card__content">
              <div className="stat-card__info">
                <p className="stat-card__label">{stat.title}</p>
                <p className="stat-card__value">{stat.value}</p>
              </div>
              <div className={`stat-card__icon stat-card__icon--${stat.color}`}>
                <IconComponent size={32} />
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}
